module.exports = __webpack_public_path__ + "static/media/groceryOrderImg.c57ba0dd.svg";